import { CtaData } from "@/ui/types/cta"
import SanityRichTextField from "@/integrations/sanity/components/SanityRichTextField"
import { NavItemData } from "@/ui/types/nav"
import { OfficeLocationDetailsData } from "@/ui/types/officeLocation"
import { toLink } from "./links"
import {
  Cta,
  EditorialContents,
  LinkItem,
  NavItem,
  OfficeLocationDetails,
} from "../sanityTypes"
import SanityImageField from "@/integrations/sanity/components/SanityImageField"
import { SanityDecoration } from "../molecules/SanityDecoration"

export const toCtaData = (cta?: Cta): CtaData | undefined => {
  return cta
    ? {
        label: <SanityRichTextField value={cta.label} />,
        variant: cta.variant ? cta.variant : undefined,
        color: cta.color,
        link: toLink(cta.link),
      }
    : undefined
}

export const toCtaList = (ctas?: EditorialContents) => {
  return ctas?.map((cta: any) => toCtaData(cta)).filter((x) => x) as Cta[]
}

export const toNavItemData = (navItem?: any): NavItemData | undefined => {
  return navItem
    ? {
        label: <SanityRichTextField value={navItem.label} />,
        link: toLink(navItem.link),
      }
    : undefined
}

export const toNavItems = (items?: NavItem[]) => {
  return items
    ?.map((item) => toNavItemData(item))
    .filter((x) => x) as NavItemData[]
}

export const toOfficeLocation = (
  officeLocation: OfficeLocationDetails
): OfficeLocationDetailsData => {
  return {
    city: officeLocation?.city!,
    buildingName: officeLocation?.buildingName!,
    address: officeLocation?.address!,
    country: officeLocation?.country!,
    image: (
      <SanityImageField
        asset={officeLocation?.image?.asset!}
        objectFit={"cover"}
        responsive
        width={345}
        height={230}
      />
    ),
    decoration: officeLocation.decoration?.image?.asset ? (
      <SanityDecoration
        asset={officeLocation.decoration.image.asset}
        position={officeLocation.decoration.position ?? {}}
        size={officeLocation.decoration.size ?? {}}
        absolute
      />
    ) : undefined,
  }
}
